import { Params } from '@angular/router';
import { FilterHandlerParams } from '~app/modules/filters/models/filter-handler-params';
import { PromotionFilterChangedPayload } from '~app/modules/filters/models';
import { blackDealFilterChangedPayload } from '~app/modules/filters/models/black-deal-filter-changed-payload.model';

export class PromotionFilterHandler {
  private static _instance: PromotionFilterHandler;
  public static get instance(): PromotionFilterHandler {
    if (!PromotionFilterHandler._instance) {
      PromotionFilterHandler._instance = new PromotionFilterHandler();
    }

    return PromotionFilterHandler._instance;
  }

  protected queryParams: Params;

  updateQueryParams(params: Params): void {
    this.queryParams = params;
  }

  apply(promotion: PromotionFilterChangedPayload | blackDealFilterChangedPayload): FilterHandlerParams {
    const {
      filter: {
        options = {},
        promotion: prevPromotion = {},
        volumePrices: prevVolumePrices = {},
        blackFriday = {},
        ...rest
      } = {},
    } = this.queryParams || {};

    return { params: { filter: { ...promotion, options, ...rest } }, config: { resetPaging: true } };
  }

  remove(promotion: PromotionFilterChangedPayload | blackDealFilterChangedPayload): FilterHandlerParams {
    return this.apply(promotion);
  }

  reset(): FilterHandlerParams {
    return this.apply({
      promotion: {},
      volumePrices: {},
    });
  }
}
